// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper___0pSvw","title":"title___UzVwv","cardsWrapper":"cardsWrapper___ulbLw","cards":"cards___SuTU9"};